import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=79470eea&scoped=true&"
import script from "./CommentInput.vue?vue&type=script&lang=js&"
export * from "./CommentInput.vue?vue&type=script&lang=js&"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=79470eea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79470eea",
  null
  
)

export default component.exports